// Path: ./src/utils/constant/stringConstant.ts
import { GfImage } from "@swagger/typescript-fetch-goflyer";

export const SUPERADMIN = "SuperAdmin";
export const TestAdminHost = "test-admin-v2.goflyer.ca";
export const FrontPage = "Front-Page";
/** Sentinel id for uncategorized flyer items — export/filter endpoints only */
export const NoCategory = "no-category";
export const rowsPerPageList = [
  {
    label: "10",
    value: 10,
  },
  {
    label: "20",
    value: 20,
  },

  {
    label: "30",
    value: 30,
  },
  {
    label: "40",
    value: 40,
  },
  {
    label: "50",
    value: 50,
  },
  {
    label: "60",
    value: 60,
  },
  {
    label: "100",
    value: 100,
  },
];

/**
 * Default placeholder image used when creating a flyer item without a product image.
 * This references the "No Image Available" asset stored in the CDN.
 */
export const NO_IMAGE_AVAILABLE: GfImage = {
  id: "a93de14b-105b-4862-93ab-f7a31b38d876",
  createdAt: new Date("2025-11-13T22:28:23.842Z"),
  updatedAt: new Date("2025-11-13T22:28:26.392Z"),
  isDeleted: false,
  alt: "No Image Available",
  fileName: "No Image Available",
  mediaType: "image/png",
  src: "https://d280crdu6dot2n.cloudfront.net/productImages/No_Image_Available_4631616147626.png",
  srcSmall:
    "https://d280crdu6dot2n.cloudfront.net/flyers/No_Image_Available_4631616147626_width_300_height_300_resizeImage_v2.jpeg",
  height: 1709,
  width: 1709,
  s3LastModified: new Date("2025-11-13T12:28:24.000Z"),
  s3Size: 420383,
  metadata: {
    size: 420,
    type: "image/png",
    width: 1709,
    height: 1709,
    extractedAt: "2025-11-13T22:28:26.387Z",
    lastModified: "2025-11-13T22:28:24.000Z",
    createdDateTime: "2025-11-13T22:28:26.000Z",
    extractionSource: "exif",
  },
};

export const FlyerEditorTooltipDescription =
  "📍 Flyer Coordinate Editor - Complete Guide\n\n" +
  "🎯 Overview:\n" +
  "It's a Flyer Coordinate Editor to add-edit-delete Coordinate Boxes on Flyer. Each box links a product to its exact location on the flyer image.\n\n" +
  "➕ Adding New Coordinate Boxes:\n" +
  "1. Click the '+ Add Box' button (top-left of canvas)\n" +
  "2. A modal will open showing all available flyer items\n" +
  "3. ⚠️ Requirements: Only items WITHOUT existing coordinates will appear\n" +
  "4. If the list is empty, all products already have coordinates assigned\n" +
  "5. Select an item from the list to place it on the current page\n" +
  "6. A new TEAL/BLUE box will appear on the canvas\n" +
  "7. 💡 Tip: To map an item, you must first create it in the main product table\n\n" +
  "🤖 AI Extraction Feature:\n" +
  "• Draw PINK boxes around products you want to extract automatically\n" +
  "• Click 'AI Extract' button to draw a pink coordinate box on the canvas\n" +
  "• Pink boxes indicate AI-powered extraction (vs. regular ORANGE/TEAL boxes)\n" +
  "• AI will automatically extract product details (name, price, description) from the boxed area\n" +
  "• The extraction job runs in the background after you save\n" +
  "• Progress updates appear every 30 seconds via toast notifications\n" +
  "• Fast jobs complete in ~2-10 seconds, complex jobs may take several minutes\n" +
  "• 💡 Best Practice: Use AI extraction for products without existing metadata\n" +
  "• ⚠️ Note: AI boxes create NEW flyer items - don't use for existing products\n\n" +
  "🔄 Deleted Items:\n" +
  "• Deleted boxes (before saving) appear with red strikethrough in the add box selection list\n" +
  "• You can re-add deleted items before saving to restore their coordinates\n" +
  "• Once you click 'Save All Changes', deletions become permanent\n" +
  "• Saved deletions remove coordinates from database\n\n" +
  "✏️ Editing Coordinate Boxes:\n" +
  "• Select: Double-click any box to select it (TEAL/BLUE border = selected, ORANGE = unselected)\n" +
  "• Deselect: Double-click a selected box again to deselect it, or click empty canvas to clear all\n" +
  "• Multi-Select: Double-click multiple boxes to select them all at the same time\n" +
  "• Right-Drag Multi-Select: Right-click and drag on empty canvas to draw a selection box and select all boxes fully inside it\n" +
  "• Move: Drag any selected box to reposition it on the flyer\n" +
  "• Group Move Toggle: Use the move-all toggle (OpenWith icon) in the toolbar to move all selected boxes together while dragging\n" +
  "• Group Move Live Sync: When group move is enabled, other selected boxes move in real-time with the dragged box\n" +
  "• Resize: Selected boxes show resize handles - drag corner handles (diagonal) or edge handles (horizontal/vertical)\n" +
  "• Info Card: Hover over a selected box to see its product info card (name, price, quantity)\n" +
  "• Edit Details: Click the pencil icon (top-right corner of the selected box) to open the product editor\n" +
  "• Delete: Press the Delete key or click the Delete button to remove ALL currently selected boxes at once\n" +
  "• AI extraction boxes (pink) can be moved and resized like regular boxes before saving\n\n" +
  "🔍 Zoom & Pan Controls:\n" +
  "• Zoom In/Out: Use mouse wheel to zoom, or click +/- buttons in the toolbar\n" +
  "• Pan View: Drag on empty canvas area to move around\n" +
  "• Reset View: Use the reset button in toolbar to return to default zoom level\n\n" +
  "💾 Saving Changes:\n" +
  "• All modifications (new boxes, moves, resizes, deletes) are tracked automatically\n" +
  "• Click 'Save All Changes' button when ready to permanently save your work\n" +
  "• ⚠️ Critical: Changes are NOT auto-saved - you MUST click 'Save All Changes'\n" +
  "• Unsaved changes will be lost if you close the editor window\n" +
  "• AI extraction starts processing AFTER you click 'Save All Changes'\n\n" +
  "⚠️ Critical Reminders:\n" +
  "• Always click 'Save All Changes' before closing the editor window\n" +
  "• Each product can only have ONE coordinate box per flyer (no duplicates allowed)\n" +
  "• Coordinate boxes are page-specific - the page number is stored with each coordinate\n" +
  "• Cropped product images are automatically processed and stored\n" +
  "• Double-click to select/deselect boxes (not single-click)\n" +
  "• Selected boxes show TEAL/BLUE border, unselected boxes show ORANGE border\n" +
  "• AI extraction boxes show PINK color (#FF2D95) to distinguish from regular boxes\n" +
  "• AI extraction is asynchronous - you can continue working while jobs process in the background";
